<div>
  <nx-pageTitle-box
    [label]="
      'Vorlage für ' +
      this.templateName +
      (this.id ? ' bearbeiten' : ' anlegen')
    "
    [bcRootLvlLabel]="'Vorlagen'"
    [bcRootLvlPath]="'settings/templates'"
    [icon]="'icon-templates'"
    [iconToolTip]=""
  ></nx-pageTitle-box>
  <div class="body flex flex-col white">
    <div
      [formGroup]="variantFormGroup"
      class="form flex flex-col basis-full border-b"
    >
      <nx-edit-text-input formControlName="name" [label]="'Name'">
      </nx-edit-text-input>
      <p-checkbox
        class="mb-3"
        [binary]="true"
        formControlName="isActive"
        [disabled]="templateVariant?.isActive"
        label="Aktiv"
        labelStyleClass="ml-2"
      ></p-checkbox>
      <ng-container *ngIf="templateType === 'EMAIL'">
        <nx-edit-text-input formControlName="subject" [label]="'Betreff'">
        </nx-edit-text-input>
        <nx-textfield-input formControlName="plainText" [label]="'Text'">
        </nx-textfield-input>
      </ng-container>

      <!-- <ngs-code-editor [theme]="theme" [codeModel]="codeModel" [options]="options" (valueChanged)="onCodeChanged($event)" class="border"
    [ngClass]="templateType === 'EMAIL'? 'small': 'large'">
    </ngs-code-editor> -->
      <ace
        [mode]="'html'"
        [ngClass]="templateType === 'EMAIL' ? 'small' : 'large'"
        id="editor1"
        [theme]="'github'"
        [(value)]="this.codeValue"
        (textChanged)="onCodeChanged($event)"
        #editor
      ></ace>

      <hr class="line" *ngIf="templateType !== 'EMAIL'" />
    </div>
    <div class="basis-1/2 flex flex-row gap-2 items-start mt-5">
      <nx-default-button
        class="confirm"
        label="Speichern"
        [disabled]="!(variantFormGroup?.valid && !variantFormGroup?.pristine)"
        (click)="saveTemplateVariant()"
      >
      </nx-default-button>
      <nx-default-button class="reject" label="Abbrechen" (click)="abort()">
      </nx-default-button>
    </div>
  </div>
</div>
